import script from "./AccessGate.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessGate.vue?vue&type=script&setup=true&lang=js"

import "./AccessGate.vue?vue&type=style&index=0&id=4fede499&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fede499"]])

export default __exports__